import React from "react";
import {
  CheckCircle2,
  ArrowRight,
  ShieldCheck,
  BadgeCheck,
  FileCheck2,
  Building2,
} from "lucide-react";
import Navbar from "../HomePage/Navbar";
const EKhataRegistration = () => {
  const features = [
    "Expert Documentation Support",
    "End-to-End Registration Assistance",
    "Trusted Bangalore Property Experts",
    "Transparent & Affordable Pricing",
  ];

  const stats = [
    { icon: <Building2 className="w-5 h-5" />, label: "1000+ Properties Assisted" },
    { icon: <ShieldCheck className="w-5 h-5" />, label: "Secure Documentation Process" },
    { icon: <BadgeCheck className="w-5 h-5" />, label: "Trusted Service Across Bangalore" },
  ];

  return (
    <div>
        <section className="relative overflow-hidden bg-gradient-to-br from-[#F8FAFC] via-white to-[#EEF2FF] min-h-screen py-16 px-4 md:px-10 font-sans -mt-20">

      {/* Background Glow Effects */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-red-100 rounded-full blur-3xl opacity-40"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-green-100 rounded-full blur-3xl opacity-40"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          
          {/* LEFT CONTENT */}
          <div className="space-y-8">
            
            {/* Tag */}
            <div className="inline-flex items-center gap-2 bg-red-50 border border-red-100 px-4 py-2 rounded-full">
              <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
              <span className="text-sm font-semibold tracking-wide uppercase text-red-600">
                Bangalore Property Services
              </span>
            </div>

            {/* Heading */}
            <div className="space-y-6">
              <h1 className="text-5xl md:text-6xl font-black leading-tight text-gray-900">
                e-Khata
                <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#E63946] to-[#ff6b6b]">
                  Registration
                </span>
              </h1>

              <p className="text-lg text-gray-600 leading-relaxed max-w-xl">
                Simplify your property registration process with{" "}
                <span className="font-semibold text-gray-900">
                  HousyHunt
                </span>
                . We provide complete assistance for e-Khata applications,
                document verification, BBMP guidance, and hassle-free approvals
                across Bangalore.
              </p>
            </div>

            {/* Features */}
            <div className="grid sm:grid-cols-2 gap-5">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="group flex items-center gap-4 bg-white/70 backdrop-blur-xl border border-gray-100 hover:border-red-200 p-4 rounded-2xl transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
                >
                  <div className="bg-gradient-to-br from-red-500 to-red-400 text-white p-2.5 rounded-xl shadow-lg">
                    <CheckCircle2 className="w-5 h-5" />
                  </div>

                  <span className="font-medium text-gray-700 group-hover:text-gray-900">
                    {feature}
                  </span>
                </div>
              ))}
            </div>

            {/* Stats */}
            <div className="grid sm:grid-cols-3 gap-4 pt-2">
              {stats.map((item, i) => (
                <div
                  key={i}
                  className="bg-white/80 backdrop-blur-lg border border-gray-100 rounded-2xl p-5 shadow-sm hover:shadow-lg transition"
                >
                  <div className="text-[#E63946] mb-3">{item.icon}</div>
                  <p className="text-sm font-semibold text-gray-700 leading-relaxed">
                    {item.label}
                  </p>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-5 pt-4">
              <button className="group relative overflow-hidden bg-gradient-to-r from-[#2ECC71] to-[#27AE60] hover:scale-105 transition-all duration-300 text-white px-8 py-4 rounded-2xl font-semibold shadow-2xl shadow-green-200 flex items-center gap-3">
                
                <span className="relative z-10">
                  Apply for e-Khata
                </span>

                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform relative z-10" />

                {/* Hover Shine */}
                <div className="absolute inset-0 bg-white/10 translate-x-[-100%] group-hover:translate-x-0 transition duration-700"></div>
              </button>

              <div className="flex items-center gap-2 text-sm text-gray-500">
                <FileCheck2 className="w-4 h-4 text-green-500" />
                Fast • Verified • Professional Assistance
              </div>
            </div>
          </div>

          {/* RIGHT IMAGE SECTION */}
          <div className="relative">
            
            {/* Main Image Card */}
            <div className="relative rounded-[2rem] overflow-hidden shadow-2xl border border-white/50 bg-white">
              
              {/* Top Badge */}
              <div className="absolute top-6 left-6 z-20 bg-white/90 backdrop-blur-xl border border-white shadow-lg px-5 py-3 rounded-2xl">
                <p className="text-xs font-bold text-red-500 uppercase tracking-widest">
                  Bangalore Exclusive
                </p>
                <h4 className="text-sm font-semibold text-gray-800">
                  e-Khata Assistance
                </h4>
              </div>

              {/* Online Image */}
              <img
                src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=1400&auto=format&fit=crop"
                alt="Property Registration"
                className="w-full h-[650px] object-cover"
              />

              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>

              {/* Bottom Info Card */}
              <div className="absolute bottom-6 left-6 right-6 bg-white/90 backdrop-blur-2xl border border-white/40 rounded-3xl p-6 shadow-xl">
                <div className="flex items-center justify-between flex-wrap gap-4">
                  
                  <div>
                    <p className="text-sm text-gray-500">
                      Trusted Property Registration Partner
                    </p>

                    <h3 className="text-2xl font-bold text-gray-900">
                      HousyHunt Bangalore
                    </h3>
                  </div>

                  <button className="bg-black text-white px-5 py-3 rounded-xl hover:bg-gray-800 transition flex items-center gap-2">
                    Explore Services
                    <ArrowRight className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </div>

            {/* Floating Glass Card */}
            <div className="absolute -bottom-8 -left-8 hidden md:block bg-white/80 backdrop-blur-2xl border border-white shadow-2xl rounded-3xl p-6 w-64">
              <div className="flex items-center gap-4">
                <div className="bg-green-100 text-green-600 p-3 rounded-2xl">
                  <ShieldCheck className="w-6 h-6" />
                </div>

                <div>
                  <h4 className="font-bold text-gray-900">
                    100% Secure Process
                  </h4>
                  <p className="text-sm text-gray-500">
                    Verified documentation support
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
    </div>
  );
};

export default EKhataRegistration;